import React, { useCallback, useEffect, useState } from 'react'
import {CardContent, CardHeader, Grid} from "@mui/material";
import { Breadcrumbs } from "../../../../Components";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { PermissionTable, AddPermission, fetchPermissions  } from "../index";
import { setRightDrawer } from "../../../Common/App";
import { TableCard } from '../../../../Components';
import useDeepEqualSelector from '../../../../Hooks/useDeepEqualSelector';

export const Permissions = () => {

    const dispatch = useDispatch();
    const [, setResponse] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const filters = useSelector((store) => store.permissions?.config?.filters);
    const pagination = useDeepEqualSelector((store) => store.permissions.config.pagination);

    const fetchItems = useCallback(async () => {
        setIsLoading(true);
        await fetchPermissions({dispatch, filters:{...pagination,...filters}}).then((res)=>{
            setResponse(res);
            setIsLoading(false);
        });
    },[pagination, filters, dispatch]);

    useEffect(() => {
        fetchItems();
    },[fetchItems]);

    const addItem = () => {
        dispatch(setRightDrawer({component:<AddPermission />, open:true}))
    };

    return (
        <Grid container spacing={2} elevated={3}>
            <Grid item xs={12}>
                <Box justifyContent={"space-between"} display={"flex"}>
                    <Breadcrumbs items={['DASHBOARD','PERMISSIONS']} />
                    <Button variant="contained" onClick={addItem}>Add Permission</Button>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <TableCard>
                    <CardHeader title={"Permissions"} />
                    <CardContent sx={{p:0}}>
                        <PermissionTable isLoading={isLoading} setIsLoading={setIsLoading} />
                    </CardContent>
                </TableCard>
            </Grid>
        </Grid>
    );
}
